import martyWaving from "../../../assets/frontMartyWaving.png";
import martyJoints from "../../../assets/martyJoints.png";
import i18n from "../../../i18n";

export enum Steps {
  STEP01 = 1,
  STEP02 = 2,
  STEP03 = 3,
  STEP04 = 4,
  STEP_EYES_01 = 10,
  STEP_EYES_02 = 11,
  STEP_ARMS_01 = 20,
  STEP_ARMS_02 = 21,
  STEP_LEGS_01 = 30,
  STEP_LEGS_02 = 31,
  STEP_COLOUR_SENSOR = 32,
  STEP_CAL_DONE = 40,
}

export const getCalibrationStrings = (step: number) => {
  switch (step) {
    case Steps.STEP01:
      return {
        title: i18n.t("calibration_screen.step01_title"),
        hint: i18n.t("calibration_screen.step01_hint"),
      };
    case Steps.STEP_EYES_01:
      return {
        title: i18n.t("calibration_screen.eyes01_title"),
        hint: i18n.t("calibration_screen.eyes01_hint"),
      };
    case Steps.STEP_ARMS_01:
      return {
        title: i18n.t("calibration_screen.arms01_title"),
        hint: i18n.t("calibration_screen.arms01_hint"),
      };
    case Steps.STEP_LEGS_01:
      return {
        title: i18n.t("calibration_screen.legs01_title"),
        hint: i18n.t("calibration_screen.legs01_hint"),
      };
    case Steps.STEP_LEGS_02:
      return {
        title: i18n.t("calibration_screen.legs02_title"),
        hint: i18n.t("calibration_screen.legs02_hint"),
      };
    case Steps.STEP_CAL_DONE:
      return {
        title: i18n.t("calibration_screen.done_title"),
        hint: i18n.t("calibration_screen.done_hint"),
      };
    case Steps.STEP_COLOUR_SENSOR:
      return {
        title: i18n.t("calibration_screen.colour_sensor_title"),
        hint: i18n.t("calibration_screen.colour_sensor_hint"),
      };
    default:
      return { title: i18n.t("calibration_screen.default_title"), hint: i18n.t("calibration_screen.default_hint") };
  }
};

export const getCalibrationButton = (step: number) => {
  switch (step) {
    case Steps.STEP_EYES_01:
      return i18n.t("calibration_screen.save_eyes");
    case Steps.STEP_ARMS_01:
      return i18n.t("calibration_screen.save_arms");
    case Steps.STEP_LEGS_01:
      return i18n.t("calibration_screen.save_legs");
    case Steps.STEP_LEGS_02:
      return i18n.t("calibration_screen.test_move");
    case Steps.STEP_CAL_DONE:
      return i18n.t("calibration_screen.back");
    case Steps.STEP_COLOUR_SENSOR:
      return i18n.t("calibration_screen.start_calibration");
    default:
      return i18n.t("calibration_screen.thank_you");
  }
};

export const getCalibrationImage = (step: number) => {
  switch (step) {
    case Steps.STEP_EYES_01:
    case Steps.STEP_ARMS_01:
    case Steps.STEP_LEGS_01:
      return martyJoints;
    default:
      return martyWaving;
  }
};
